import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { CartResponse } from './../../../../models/cart.model';
import { ProductCartRequest, ProductCartResponse } from './../../../../models/product.model';
import { FeatherIconsComponent } from '../../feather-icons/feather-icons.component';
import { CartService } from '../../../services/order/cart.service';
import { EventEmitterService } from '../../../services/utils/event-emitter.service';
import { CommonSvgIconComponent } from '../../common-svg-icon/common-svg-icon.component';
import { formatUSD, showNotification } from '../../../../consts/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-cart',
  imports: [FeatherIconsComponent, RouterModule, CommonSvgIconComponent,],
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})

export class CartComponent {

  public isShow: boolean = false;
  public cart: CartResponse;
  private eventSubscription: Subscription;

  constructor(private _cartService: CartService,
    private _router: Router,
    private snackBar: MatSnackBar,
    private _eventEmitterService: EventEmitterService) { }

  ngOnInit(): void {
    this.eventSubscription = this._eventEmitterService.event$.subscribe(data => {
      if (data == "refreshCart") {
        this.refreshCart();
      }
    });
    this.refreshCart();
  }

  remove(product: ProductCartResponse) {
    Swal.fire({
      text: "Are you sure you want to remove this item from cart?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {
        this._cartService.deleteProduct(this.cart._id, product.productId).subscribe({
          next: (response: any) => {
            localStorage.setItem("cart", JSON.stringify(response.data))
            this._eventEmitterService.emitEvent("refreshCart");
            this.refreshCart();
            showNotification(this.snackBar, 'The product was removed to the cart', 'success');
          },
          error: (error) => {
            showNotification(this.snackBar, error.message, 'error');
          },
        });
      }
    });
  }

  refreshCart() {
    const cartSTR = localStorage.getItem("cart");
    if (cartSTR) {
      this.cart = JSON.parse(cartSTR);
    }
  }

  decrement(product: ProductCartResponse) {
    if (product.quantity > 1) {
      product.quantity -= 1;
      const productUpdate: ProductCartRequest = {
        productId: product.productId,
        quantity: product.quantity
      }
      this._cartService.updateProduct(this.cart._id, product.productId, productUpdate).subscribe({
        next: (response: any) => {
          localStorage.setItem("cart", JSON.stringify(response.data));
          this._eventEmitterService.emitEvent("refreshCart");
          this.refreshCart();
        },
        error: (error) => {
        },
      });
    } else {
      this.remove(product);
    }
  }

  increment(product: ProductCartResponse) {
    product.quantity += 1;
    const productUpdate: ProductCartRequest = {
      productId: product.productId,
      quantity: product.quantity
    }
    this._cartService.updateProduct(this.cart._id, product.productId, productUpdate).subscribe({
      next: (response: any) => {
        localStorage.setItem("cart", JSON.stringify(response.data));
        this._eventEmitterService.emitEvent("refreshCart");
        this.refreshCart();
      },
      error: (error) => {
      },
    });
  }

  checkout() {
    this._cartService.saveOrder(this.cart._id).subscribe({
      next: (response:any) => {
        localStorage.setItem("order", JSON.stringify(response.data));
        this._router.navigate(['/checkout']);
      },
      error: (error) => {
      },
    });
  }

  formatAmount(amount: any){
    return formatUSD(amount);
  }

}
